import { COMMON_HTTP_I18N_KEYS } from '../../../common/i18n/Commoni18nConstants';

export const COMMON_HTTP_I18N_EN = {
  [COMMON_HTTP_I18N_KEYS.authentication_failed_or_expired]:  'Authentication failed or expired. Please log in again.',
};


// WEBPACK FOOTER //
// ./src/locales/en/common/http.i18n.en.js